import { ToolHandler, ToolApplyContext } from '../tool-handler.interface'
import { ToolConfig, SetupGuideAiMessage, ArticleSearchResultEntry } from '../../types/ai-chat.types'

export class SearchArticlesHandler implements ToolHandler {
  name = 'search_articles'
  config: ToolConfig = {
    labelKey: 'SETUP_GUIDE.AI_CHAT.TOOL.SEARCH_ARTICLES.LABEL',
    generatingKey: 'SETUP_GUIDE.AI_CHAT.TOOL.SEARCH_ARTICLES.GENERATING',
    resultKey: 'SETUP_GUIDE.AI_CHAT.TOOL.SEARCH_ARTICLES.RESULT',
    displayType: 'articles',
    dashboardPage: 'general',
  }

  getPreviewData(message: SetupGuideAiMessage): ArticleSearchResultEntry[] {
    if (!message.toolContent || !Array.isArray(message.toolContent)) {
      return []
    }
    return message.toolContent as ArticleSearchResultEntry[]
  }

  canApply(_message: SetupGuideAiMessage): boolean {
    return false
  }

  apply(_message: SetupGuideAiMessage, _context: ToolApplyContext): void {}
}
